import * as React from "react";
import Agreement from "src/components/Agreement";
import { useGameContext } from "src/game/useGameContext";
import {
  AgreementHeading,
  AgreementWrapper,
  AverageAndAgreementWrapper,
  AverageHeading,
  AverageValue,
  AverageWrapper,
  EndTurnSummaryWrapper,
} from "./EndTurnSummary.components";

const EndTurnSummary: React.FunctionComponent = () => {
  const {
    gameState: { voteReveal },
  } = useGameContext();

  if (!voteReveal) {
    return null;
  }

  return (
    <EndTurnSummaryWrapper data-cy="endTurn">
      <AverageAndAgreementWrapper>
        <AverageWrapper>
          <AverageValue>{voteReveal.avgScore}</AverageValue>
          <AverageHeading>Average</AverageHeading>
        </AverageWrapper>
        <AgreementWrapper>
          <Agreement value={voteReveal.agreementScore} />
          <AgreementHeading>Agreement</AgreementHeading>
        </AgreementWrapper>
      </AverageAndAgreementWrapper>
    </EndTurnSummaryWrapper>
  );
};

export default EndTurnSummary;
